import { FallbackImage } from "src/pages/diet/DietPage";
import { ModalBottom } from "../ModalBottom";
import { ReactComponent as IconNoPill } from "../../../styles/assets/svg/icon_pill_empty.svg";
import { formatToAmPm } from "src/common/hooks/userTimeFormat";
import { PopupButtons } from "src/components/atoms/PopupAlert/PopupAlert.style";
import { titleText } from "src/components/atoms/MainHeaderBox/MainConHeader";

interface ModalTakeTimeProps {
  selectedItem: any;
  selectedTime: string; // "HH:mm:ss" 형태
  setSelectedTime: (time: string) => void;
  openTime: boolean;
  setOpen: (open: boolean) => void;
  setOpenTime: (open: boolean) => void;
  handleUpdateHistory: (time: string) => void;
  handleDeleteHistory: () => void;
}

export const ModalTakeTime = ({
  selectedItem,
  selectedTime,
  setOpen,
  setOpenTime,
  handleDeleteHistory,
}: ModalTakeTimeProps) => {
  return (
    <ModalBottom
      title="복용 기록 수정"
      onClose={() => setOpen(false)}
      onRow={false}
    >
      <div
        style={{
          padding: "0 16px",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          {selectedItem.fileUrl === null ? (
            ""
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 48,
                height: 48,
                position: "relative",
                borderRadius: 16,
                overflow: "hidden",
                background: "var(--neutral-100, #F5F5F5)",
              }}
            >
              {selectedItem.fileUrl ? (
                <FallbackImage
                  src={process.env.REACT_APP_API_FILE + selectedItem.fileUrl}
                  alt={selectedItem.mediName}
                />
              ) : (
                <IconNoPill />
              )}
            </div>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  ...titleText,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {selectedItem.mediName}
              </div>
            </div>
            <div
              style={{
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              {formatToAmPm(selectedTime)}
            </div>
          </div>
        </div>
        <PopupButtons style={{ padding: 0 }}>
          <button
            type="button"
            className="cancel_btn"
            onClick={() => handleDeleteHistory()}
          >
            복용 취소
          </button>
          <button
            type="button"
            className="confirm_btn"
            onClick={() => {
              setOpen(false);
              setOpenTime(true);
            }}
          >
            수정하기
          </button>
        </PopupButtons>
      </div>
    </ModalBottom>
  );
};
